import { css } from "@emotion/css";
import { mergeProps } from "@react-aria/utils";
import { Column as AriaColumn, ColumnProps } from "react-aria-components";

import { getTextStyle } from "../../../foundations/typography/styles";
import { textAlignment } from "../../data-tables/assets/Cell";

interface Props extends ColumnProps {
  textAlignment?: textAlignment;
}

export function DataColumn(props: Props) {
  const styles = getStyles(props.textAlignment || "left");
  return (
    <AriaColumn
      {...mergeProps(props, {
        className: css(styles.column, props.width && { width: props.width }),
      })}
    >
      {(columnRenderProps) => (
        <>
          {typeof props.children === "function"
            ? props.children(columnRenderProps)
            : props.children}
        </>
      )}
    </AriaColumn>
  );
}
function getStyles(textAlignment: textAlignment) {
  return {
    column: css(getTextStyle("global/heading-medium"), {
      paddingTop: "var(--space-2-5)",
      paddingBottom: "var(--space-2-5)",
      paddingLeft: 0,
      paddingRight: "var(--space-5)",
      textAlign: textAlignment,
      "&[data-focus-visible]": {
        boxShadow: "var(--focus-action)",
      },
    }),
  };
}
